export type SapParameterValueTypes = "Fixed" | "Customer" | "ProductType"

export interface SapParameterValueTypeOption {
    value: string;
    label: string;
}

export const sapParameterValueTypesOptions: SapParameterValueTypeOption[]
    = [
        {
            value: "",
            label: ""
        },
        {
            value: "Fixed",
            label: "Fixed Value"
        },
        {
            value: "Customer",
            label: "Customer"
        },
        {
            value: "ProductType",
            label: "Product Type"
        }
    ]